export function downloadExcelFile(fileDownloadOptions) {
  if (typeof fileDownloadOptions?.fileContent !== "string" || !fileDownloadOptions.fileContent.trim()) {
    throw new Error("Invalid or empty file content received");
  }

  let byteArray;
  try {
    const base64 = fileDownloadOptions.fileContent.replace(/\s+/g, "")
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const BASE64_REGEX = /^[A-Za-z0-9+/]*={0,2}$/;
    if (!BASE64_REGEX.test(base64)) {
      throw new Error("Invalid or empty file content received");
    }

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    byteArray = new Uint8Array(byteNumbers);
  } catch (decodeError) {
    throw new Error("Failed to decode file content: invalid base64 data");
  }

  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileDownloadOptions.fileName);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 200);
}
